/* unplugin-vue-components disabled */import script from "./AccountPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountPage.vue?vue&type=script&setup=true&lang=js"

import "./AccountPage.vue?vue&type=style&index=0&id=c78f93ea&scoped=true&lang=less"

import exportComponent from "/Users/zhangxuan/Documents/Projects/VinesDjango/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c78f93ea"]])

export default __exports__